export default __webpack_public_path__ + "static/media/zpaq.b00d62c6.jpg";